export default __webpack_public_path__ + "static/media/error-icon.7dae0f30.svg";